import { BrowserRouter, useLocation, useRoutes } from 'react-router-dom';
import './App.css';
import { routes } from './routes';
import { AppUpdate } from './components/AppUpdate';

const AppRoutes = () => {
  const location = useLocation();
  const content = useRoutes(routes);
  return (
    <AppUpdate
      audience={
        ['/view', '/cast-receiver'].includes(location.pathname) ||
        new URLSearchParams(location.search).get('mode') === 'view'
      }
    >
      {content}
    </AppUpdate>
  );
};

export const App = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};
